import { makeInflect } from "../../utils/makeInflect.js";
import { ProductSizeLabelType } from "../ProductSizeLabelType.js";

export const inflectProductSizeLabelType: Record<ProductSizeLabelType, ReturnType<typeof makeInflect>> = {
	[ProductSizeLabelType.Serving]: makeInflect("porce", "porce", "porcí"),
	[ProductSizeLabelType.Pieces]: makeInflect("kus", "kusy", "kusů"),
	[ProductSizeLabelType.Kilograms]: makeInflect("kilogram", "kilogramy", "kilogramů"),
	[ProductSizeLabelType.Grams]: makeInflect("gram", "gramy", "gramů"),
};
